import { generateTranslations } from '../../i18n/translation';

const namespace = 'alpTable';

const translations = generateTranslations(namespace, {
  sortColumn: {
    nb: 'Sorter kolonne { colName }',
    en: 'Sort column { colName }',
  },
  searchColumn: {
    nb: 'Søk i kolonne { colName }',
    en: 'Search in column { colName }',
  },
});

export default translations;
